import { useEffect, useState } from "react";
import { FileArchive, Lock } from "lucide-react";
import { API, api } from "@/lib/api";
import { PageHeader } from "@/components/Layout";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Badge } from "@/components/ui/badge";
import { toast } from "sonner";

const monthStart = () => `${new Date().toISOString().slice(0, 7)}-01`;

export default function CaExport() {
  const [status, setStatus] = useState(null);
  const [range, setRange] = useState({ from: monthStart(), to: new Date().toISOString().slice(0, 10) });

  useEffect(() => {
    api.get("/secure-export/status").then(({ data }) => setStatus(data)).catch(() => setStatus({}));
  }, []);

  const allowed = status?.can_export_ca_bills;

  return (
    <div>
      <PageHeader
        testId="ca-export-header"
        title="CA / GST bill export"
        subtitle="One ZIP with every original purchase bill, invoice copy and the GST summary sheets for filing"
      />
      <div className="p-4 sm:p-6">
        {!allowed ? (
          <div className="surface p-10 text-center" data-testid="ca-export-locked">
            <Lock className="mx-auto mb-2 h-5 w-5 text-muted-foreground" />
            <p className="text-sm">
              This section is switched off for your account. Ask the Owner to enable
              <b> Can export CA / GST bills</b> in your employee profile.
            </p>
          </div>
        ) : (
          <div className="surface max-w-xl space-y-3 p-5" data-testid="ca-export-panel">
            <div className="flex flex-wrap gap-3">
              <div>
                <div className="overline">From</div>
                <Input type="date" className="w-[160px]" value={range.from}
                  data-testid="ca-from-input"
                  onChange={(e) => setRange({ ...range, from: e.target.value })} />
              </div>
              <div>
                <div className="overline">To</div>
                <Input type="date" className="w-[160px]" value={range.to}
                  data-testid="ca-to-input"
                  onChange={(e) => setRange({ ...range, to: e.target.value })} />
              </div>
            </div>
            <Button className="gap-1.5" data-testid="ca-export-zip-button"
              onClick={() => {
                window.open(
                  `${API}/secure-export/ca-bills?date_from=${range.from}&date_to=${range.to}`,
                  "_blank");
                toast.success("Preparing the ZIP — it will download shortly");
              }}>
              <FileArchive className="h-4 w-4" /> Export GST &amp; purchase bills (.ZIP)
            </Button>
            <p className="text-[11px] text-muted-foreground">
              The pack contains the original bill photos and PDFs, a purchase summary and a
              GST sales summary. Customer and lead lists are never included.
            </p>
            {status?.is_owner && (
              <Badge variant="outline" className="text-[10px]">
                You are the Owner — this section is always available to you
              </Badge>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
